import moment from 'moment';

const PARSE_FORMAT = 'YYYY-MM-DD HH:mm';

function formatCourseDate(value: string, format: string) {
  return moment.utc(value, PARSE_FORMAT).format(format);
}

export function formatCourseDay(value: string) {
  return formatCourseDate(value, 'dd, DD.MM.YYYY');
}

export function formatCourseTime(value: string) {
  return formatCourseDate(value, 'HH:mm');
}

export function formatCourseTimeRange(start: string, end: string) {
  return `${formatCourseTime(start)} - ${formatCourseTime(end)}`;
}
